import SkeletonLoader from 'common/components/skeleton-loader';
import React from 'react';
import './StripeViewSkeleton.styles';

function StripeViewSkeleton() {
  return (
    <div className="stripe-view-skeleton">
      <SkeletonLoader className="title" round />
      <div className="list">
        <SkeletonLoader className="card-box" />
        <SkeletonLoader className="card-box" />
        <SkeletonLoader className="card-box" />
        <SkeletonLoader className="card-box" />
        <SkeletonLoader className="card-box" />
      </div>
      <SkeletonLoader className="title" round />
      <div className="list">
        <SkeletonLoader className="card-box" />
        <SkeletonLoader className="card-box" />
        <SkeletonLoader className="card-box" />
        <SkeletonLoader className="card-box" />
        <SkeletonLoader className="card-box" />
      </div>
    </div>
  );
}

export default React.memo(StripeViewSkeleton);
